import * as Sentry from '@sentry/vue';
import type { MissingTranslationPayload } from '@tundr/i18n';
import { MISSING_I18N_TAG } from './missing-translation-tag.ts';

const MISSING_I18N_FINGERPRINT = 'missing-i18n-translation' as const;

/**
 * Sends a Sentry warning for a missing Vue I18n key. No-ops when Sentry is not initialised.
 */
export function reportMissingTranslationToSentry(
  payload: MissingTranslationPayload,
): void {
  const client = Sentry.getClient();
  if (!client) {
    return;
  }

  Sentry.withScope((scope) => {
    scope.setLevel('warning');
    scope.setTag(MISSING_I18N_TAG, 'true');
    scope.setContext('i18n', {
      key: payload.key,
      locale: payload.locale,
      ...(payload.type !== undefined ? { type: payload.type } : {}),
    });
    scope.setFingerprint([
      MISSING_I18N_FINGERPRINT,
      payload.locale,
      payload.key,
    ]);
    Sentry.captureMessage(`Missing translation: ${payload.key}`);
  });
}
